import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b17cef8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "Template_head_title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Redprompt = _resolveComponent("Redprompt")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Template_head", { myLine: _ctx.isLine }]),
    style: _normalizeStyle(_ctx.radius ? 'border-radius: 20px 20px 0 0' : '')
  }, [
    _createElementVNode("img", {
      src: _ctx.img,
      alt: ""
    }, null, 8, _hoisted_1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1),
    (_ctx.text)
      ? (_openBlock(), _createBlock(_component_Redprompt, {
          key: 0,
          isText: _ctx.isText,
          text: _ctx.text
        }, null, 8, ["isText", "text"]))
      : _createCommentVNode("", true)
  ], 6))
}